import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Marketplace from "@/pages/Marketplace";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AdminUsers from "@/pages/AdminUsers";
import PaymentResult from "@/pages/PaymentResult";
import Maintenance from "@/pages/Maintenance";

const MAINTENANCE = process.env.REACT_APP_MAINTENANCE_MODE === "true";

function Shell({ children }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/about" element={<Shell><About /></Shell>} />
      <Route path="/how-it-works" element={<Shell><HowItWorks /></Shell>} />
      <Route path="/login" element={<Shell><Login /></Shell>} />
      <Route path="/marketplace" element={<Shell><Marketplace /></Shell>} />
      <Route path="/opportunity/:id" element={<Shell><OpportunityDetail /></Shell>} />
      <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
      <Route path="/admin" element={<Shell><Admin /></Shell>} />
      <Route path="/admin/users" element={<Shell><AdminUsers /></Shell>} />
      <Route path="/payment/success" element={<Shell><PaymentResult /></Shell>} />
      <Route path="/payment/cancel" element={<Shell><PaymentResult /></Shell>} />
    </Routes>
  );
}

function App() {
  if (MAINTENANCE) {
    return <Maintenance />;
  }
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
